import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-security-form',
  standalone: true,
  imports: [],
  templateUrl: './app-settings-security-form.component.html',
  styleUrl: './app-settings-security-form.component.css'
})
export class AppSettingsSecurityFormComponent {

}
